<h2 mat-dialog-title>Détails du device</h2>

<mat-dialog-content class="device-details">
  <!-- Champs communs -->
  <p><strong>Nom :</strong> {{ deviceRg?.nomAgent || deviceBit?.nom }}</p>
  <p><strong>OS :</strong> {{ deviceRg?.os || deviceBit?.os }}</p>
  <p>
    <strong>Type :</strong> {{ deviceRg?.type?.libelle || deviceBit?.type?.libelle }}
  </p>

  <!-- Cas RG -->
  <ng-container *ngIf="deviceRg">
    <p>
      <strong>Dernière communication :</strong>
      {{ deviceRg.lastCommunication | date : "dd/MM/yyyy HH:mm:ss" }}
    </p>
    <p><strong>RAM :</strong> {{ deviceRg.infoRam }}</p>
    <p><strong>Stockage :</strong> {{ deviceRg.infoStockage }}</p>
  </ng-container>

  <!-- Cas BIT -->
  <ng-container *ngIf="deviceBit">
    <h3>Modules installés :</h3>
    <mat-list>
      <mat-list-item>
        - ATS :
        <span
          class="{{
            deviceBit.haveAts ? 'status-installed' : 'status-not-installed'
          }}"
        >
          {{ deviceBit.haveAts ? "Installé" : "Non installé" }}
        </span>
      </mat-list-item>
      <mat-list-item>
        - EDR :
        <span
          class="{{
            deviceBit.haveEdr ? 'status-installed' : 'status-not-installed'
          }}"
        >
          {{ deviceBit.haveEdr ? "Installé" : "Non installé" }}
        </span>
      </mat-list-item>
      <mat-list-item>
        - MDR :
        <span
          class="{{
            deviceBit.haveMdr ? 'status-installed' : 'status-not-installed'
          }}"
        >
          {{ deviceBit.haveMdr ? "Installé" : "Non installé" }}
        </span>
      </mat-list-item>
      <mat-list-item>
        - CRY :
        <span
          class="{{
            deviceBit.haveCry ? 'status-installed' : 'status-not-installed'
          }}"
        >
          {{ deviceBit.haveCry ? "Installé" : "Non installé" }}
        </span>
      </mat-list-item>
      <mat-list-item>
        - PATCH :
        <span
          class="{{
            deviceBit.havePatch ? 'status-installed' : 'status-not-installed'
          }}"
        >
          {{ deviceBit.havePatch ? "Installé" : "Non installé" }}
        </span>
      </mat-list-item>
    </mat-list>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>
